module.exports = __webpack_public_path__ + "fb16d5376a1bd8daec88fdbab4c0b047.svg";